import { Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, TEL_URL, INSTAGRAM_URL, MAPS_URL, PHONE_DISPLAY } from "../i18n";

export const Footer = ({ t }) => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-neutral-800 bg-neutral-950 text-neutral-400"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center bg-green-600 text-white">
                <span className="text-sm font-black tracking-tighter">CA</span>
              </span>
              <div className="font-display text-xl font-black tracking-tighter text-white">
                CNG AutoCare
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mb-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-neutral-500">
              {t.footer.nav}
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="transition-colors hover:text-green-400">{t.nav.services}</a></li>
              <li><a href="#calculator" className="transition-colors hover:text-green-400">{t.nav.calculator}</a></li>
              <li><a href="#why" className="transition-colors hover:text-green-400">{t.nav.whyUs}</a></li>
              <li><a href="#contact" className="transition-colors hover:text-green-400">{t.nav.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="mb-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-neutral-500">
              {t.footer.reach}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={TEL_URL} className="group flex items-center gap-3 transition-colors hover:text-green-400">
                  <Phone size={14} /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 transition-colors hover:text-green-400">
                  <MessageCircle size={14} /> WhatsApp
                </a>
              </li>
              <li>
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 transition-colors hover:text-green-400">
                  <MapPin size={14} /> Ubungo Maziwa Road
                </a>
              </li>
              <li>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 transition-colors hover:text-green-400">
                  <Instagram size={14} /> @cng_autocare_tz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-neutral-800 pt-8 text-xs text-neutral-500 sm:flex-row sm:items-center">
          <div>© 2026 CNG AutoCare. {t.footer.rights}</div>
          <div className="uppercase tracking-[0.2em]">Dar es Salaam · Tanzania</div>
        </div>
      </div>
    </footer>
  );
};
